// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Form, Button, TextArea, Segment } from 'semantic-ui-react'

export default class Contact extends Component {
  render () {
    return (
      <Container className='masterdiv'>
        <div className='slavediv procedure'>
          <Segment padded='very'>
            <div className='mb'>
              <h2>Get in touch</h2>
            </div>
            <Form
              className='mtb'
              enctype='multipart/form-data'
              action='https://getform.io/f/68a50b3f-4810-466b-addc-27465979e137'
              method='POST'>
              <Form.Field required>
                <label>Full name</label>
                <input type='text' name='name' />
              </Form.Field>
              <Form.Field required>
                <label>Email address</label>
                <input type='text' name='email' />
              </Form.Field>
              <Form.Field required>
                <label>Message</label>
                <TextArea rows={5} type='text' name='message' />
              </Form.Field>
              <Button size='small' type='submit'>
                Send
              </Button>
            </Form>
            <h5>
              Some account and system information may be sent to Murkstom. We will use the
              information you give us to help address technical issues and to improve our services,
              subject to our <a href='/privacy'>Privacy Policy</a> and{' '}
              <a href='/terms'>Terms of Service</a>.
            </h5>
          </Segment>
        </div>
      </Container>
    )
  }
}
